'use strict'
const REGISTRANT_ID_TYPE_I = {
  SFZ: '身份证',
  HZ: '护照',
  TXZ: '港澳居民来往内地通行证',
  TWSFZ: '台湾居民来往大陆通行证',
  GWSFZ: '外国人永久居留身份证'
}
const REGISTRANT_ID_TYPE_E = {
  ORG: '组织机构代码证',
  YYZZ: '工商营业执照',
  TYDMZ: '统一社会信用代码证书',
  BDDH: '部队代号',
  JDXKZ: '军队单位对外有偿服务许可证',
  SYZS: '事业单位法人证书',
  GWCZDJZ: '外国企业常驻代表机构登记证',
  STDJZ: '社会团体法人登记证书',
  ZJDJZ: '宗教活动场所登记证',
  MBDJZ: '民办非企业单位登记证书',
  JJDJZ: '基金会法人登记证书',
  LSXKZ: '律师事务所执业许可证',
  GWZHDJZ: '外国在华文化中心登记证',
  GWLYDJZ: '外国政府旅游部门常驻代表机构批准登记证',
  SFXKZ: '司法鉴定许可证',
  GWJGZJ: '外国机构证件',
  SHFWJGZ: '社会服务机构登记证书',
  MBXXXKZ: '民办学校办学许可证',
  YLJGXKZ: '医疗机构执业许可证'
}
const DOMAIN_TRANSFER_STATUS = {
  1: '待转移',
  2: '转移中',
  3: '转移成功',
  4: '转移失败',
  5: '转移成功信息更新中',
  6: '转移成功信息更新完成',
  7: '转移成功信息更新失败'
}
const ORDER_TYPE = {
  1: '新开',
  2: '续费',
  3: '退费',
  4: '转入'
}
const DOMAIN_CHANGE_TYPE = {
  0: '待过户',
  1: '过户中',
  2: '过户完成',
  3: '过户失败'
}
const REAL_NAME_VERIFY_STATUS = {
  0: '未提交资料',
  1: '审核中',
  2: '审核通过',
  3: '审核拒绝'
}
const DOMAIN_NAME_VERIFY_STATUS = {
  0: '未审核',
  1: '审核中',
  2: '审核通过',
  3: '审核拒绝'
}
const IMPORTANT_FLAG = {
  0: '一般保护',
  1: '重点保护',
  2: '不支持'
}
const RENEWFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持'
}
const UPDATEFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持'
}
const TRANSFERLOCKFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持'
}
const DELETELOCKFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持'
}
const WHOISPRIVACYFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持',
  4: '已到期'
}
const BACKENDLOCKFLAG = {
  0: '未开通',
  1: '已开通',
  2: '不支持',
  3: '未购买',
  4: '已到期'
}
const SERVICE_TYPE = {
  'renewFlag': '自动续费',
  'updateFlag': '禁止更新',
  'backendLockFlag': '注册局锁',
  'transferLockFlag': '禁止转移',
  'deleteLockFlag': '禁止删除',
  'whoisPrivacyFlag': 'WHOIS隐私保护'
}
const SERVICE_STATE = {
  0: '服务期',
  1: '续费期',
  2: '偿还期'
}
const MGMT_TYPE = {
  0: '自主管理',
  1: '托管管理'
}
const RECORD_DOMAIN_EVENT_TYPE = {
  1: '域名到期时间提醒',
  2: '域名状态修改',
  3: '域名DNS修改',
  4: '域名信息修改',
  5: '域名过户',
  6: '域名解析修改',
  7: '域名所属管理公司修改',
  8: '域名安全设置',
  9: '域名实名认证',
  10: '域名转入'
}
const RECORD_USER_EVENT_TYPE = {
  1: '修改登录密码',
  2: '修改账号信息',
  3: '修改角色信息',
  4: '修改企业信息',
  5: '修改分组信息',
  6: '域名注册',
  7: '域名续费',
  8: '域名转入',
  9: '域名信息修改',
  10: '域名安全设置',
  11: '登录',
  12: '登出',
  13: '实名制模板修改',
  14: '修改品牌信息',
  15: '修改关注域名'
}
const RECORD_FOCUS_DOMAIN_EVENT_TYPE = {
  11: '域名注册情况监控',
  12: '域名WHOIS信息变更',
  13: '域名到期时间变更',
  14: '域名状态变化',
  15: '域名指向网站变化',
  16: '域名出售监控',
  17: '域名抢注监控'
}
const MONITOR_LOG = {
  1: '重要监控记录',
  2: '普通监控记录'
}
const DOMAIN_SUFFIX = {
  '.com': '.com',
  '.cn': '.cn',
  '.net': '.net',
  '.com.cn': '.com.cn',
  '.xyz': '.xyz',
  '.cc': '.cc',
  '.club': '.club',
  'otherSuffix': '其他后缀'
}
const UNIT = {
  'Y': '年',
  'M': '月',
  'C': '次'
}
const BUSINESS_LIST = {
  register: '域名注册',
  renew: '域名续费',
  repurchase: '域名回购',
  protection: '域名保护',
  transferIn: '域名转入'
}
const ORDER_GOODS_TYPE = {
  1: '域名注册',
  2: '域名续费',
  3: '域名回购',
  4: '域名注册局锁',
  5: '域名转入'
}
const PAY_TYPE = {
  1: '预付款存入',
  2: '信用消费',
  3: '预付款消费',
  4: '退款',
  5: '结款',
  6: '信用额度增加'
}
const QUESTION_TYPE = {
  1: '委托注册',
  2: '域名回购',
  3: '安全问题',
  4: '财务问题',
  5: '托管域名信息修改及续费',
  6: '域名赎回',
  7: '注册局锁',
  8: '其它问题'
}
const QUESTION_MODIFY_TYPE = {
  1: '续费',
  2: '解析设置',
  3: '修改DNS',
  4: '修改域名信息',
  5: '过户',
  6: '其它'
}
const SECURITY_TYPE = {
  1: '域名解析被篡改',
  2: '账号登录异常',
  3: '域名过期未续费',
  4: '其他问题'
}
const ORDER_PAY_TYPE = {
  1: '信用消费',
  2: '预付费消费'
}
const ORDER_MODE = {
  1: '用户下单',
  2: '系统下单',
  3: '线下下单'
}
const BRAND_LEVEL = {
  1: '集团名称/核心品牌',
  2: '主要产品品牌',
  3: '次要产品品牌/内部使用',
  4: '防御性品牌',
  5: '其他'
}
// 行政区域后缀
const SUFFIX_ADMINISTRATIVE_AREA = [{
  label: '.bj.cn',
  value: '.bj.cn',
  isProvince: true,
  checked: true
},
{
  label: '.sh.cn',
  value: '.sh.cn',
  isProvince: true,
  checked: true
},
{
  label: '.tj.cn',
  value: '.tj.cn',
  isProvince: true,
  checked: true
},
{
  label: '.cq.cn',
  value: '.cq.cn',
  isProvince: true,
  checked: true
},
{
  label: '.he.cn',
  value: '.he.cn',
  isProvince: true,
},
{
  label: '.sx.cn',
  value: '.sx.cn',
  isProvince: true,
  checked: true
},
{
  label: '.ln.cn',
  value: '.ln.cn',
  isProvince: true,
  checked: true
},
{
  label: '.jl.cn',
  value: '.jl.cn',
  isProvince: true,
  checked: true
},
{
  label: '.hl.cn',
  value: '.hl.cn',
  isProvince: true,
},
{
  label: '.zj.cn',
  value: '.zj.cn',
  isProvince: true,
},
{
  label: '.ah.cn',
  value: '.ah.cn',
  isProvince: true,
  checked: true
},
{
  label: '.fj.cn',
  value: '.fj.cn',
  isProvince: true,
  checked: true
},
{
  label: '.sd.cn',
  value: '.sd.cn',
  isProvince: true,
},
{
  label: '.ha.cn',
  value: '.ha.cn',
  isProvince: true,
},
{
  label: '.hb.cn',
  value: '.hb.cn',
  isProvince: true,
},
{
  label: '.gd.cn',
  value: '.gd.cn',
  isProvince: true,
},
{
  label: '.gx.cn',
  value: '.gx.cn',
  isProvince: true,
},
{
  label: '.hi.cn',
  value: '.hi.cn',
  isProvince: true,
},
{
  label: '.gz.cn',
  value: '.gz.cn',
  isProvince: true,
},
{
  label: '.yn.cn',
  value: '.yn.cn',
  isProvince: true,
},
{
  label: '.xz.cn',
  value: '.xz.cn',
  isProvince: true,
},
{
  label: '.gs.cn',
  value: '.gs.cn',
  isProvince: true,
},
{
  label: '.qh.cn',
  value: '.qh.cn',
  isProvince: true,
},
{
  label: '.nx.cn',
  value: '.nx.cn',
  isProvince: true,
},
{
  label: '.tw.cn',
  value: '.tw.cn',
  isProvince: true,
},
{
  label: '.hk.cn',
  value: '.hk.cn',
  isProvince: true,
},
{
  label: '.mo.cn',
  value: '.mo.cn',
  isProvince: true,
},
{
  label: '.nm.cn',
  value: '.nm.cn',
  isProvince: true,
},
{
  label: '.js.cn',
  value: '.js.cn',
  isProvince: true,
},
{
  label: '.jx.cn',
  value: '.jx.cn',
  isProvince: true,
},
{
  label: '.hn.cn',
  value: '.hn.cn',
  isProvince: true,
},
{
  label: '.sc.cn',
  value: '.sc.cn',
  isProvince: true,
  checked: true
},
{
  label: '.sn.cn',
  value: '.sn.cn',
  isProvince: true,
},
{
  label: '.xj.cn',
  value: '.xj.cn',
  isProvince: true,
  checked: true
},
]
// 中文域名后缀
const SUFFIX_CHINESE = [
  {
    label: '.中国',
    value: '.中国',
    tips: '.中国代表中国，我们是认真的',
    href: 'http://www.xinnet.com/domain/tld-cnywsz.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.商标',
    value: '.商标',
    tips: '网络化的新型商标',
    href: '',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.网址',
    value: '.网址',
    tips: '企业名称即网址从此推广不用愁',
    href: 'http://www.xinnet.com/domain/wangzhi.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.手机',
    value: '.手机',
    tips: '手机端专属域名',
    href: 'http://www.xinnet.com/domain/phone.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.公司',
    value: '.公司',
    tips: '.公司域名公司、品牌名称即域名',
    href: 'http://www.xinnet.com/domain/tld-cngs.html',
    addCart: false,
    query: false,
    show: true,
  },
  {
    label: '.网络',
    value: '.网络',
    tips: '网络服务企业优选',
    href: 'http://www.xinnet.com/domain/tld-cnwl.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.我爱你',
    value: '.我爱你',
    tips: '互联网告白神器',
    href: 'http://www.xinnet.com/domain/love.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.企业',
    value: '.企业',
    tips: '.企业域名即企业名称',
    href: 'http://www.xinnet.com/domain/qiye.html',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.中文网',
    value: '.中文网',
    tips: '本土商业文化中文域名',
    href: 'http://www.xinnet.com/domain/zww.html',
    addCart: false,
    query: false,
    show: true
  },
  {
    label: '.集团',
    value: '.集团',
    tips: '塑集团品牌的优选',
    href: 'http://www.xinnet.com/domain/jt.html',
    addCart: false,
    query: false,
    show: true,
  },
  {
    label: '.在线',
    value: '.在线',
    tips: '符合中国文化习惯的中文域名',
    href: 'http://www.xinnet.com/domain/online.html',
    addCart: false,
    query: false,
    show: true
  },
  {
    label: '.移动',
    value: '.移动',
    tips: '移动互联的网络标识',
    href: 'https://www.xinnet.com/domain/yidong.html',
    addCart: false,
    query: false,
    show: true
  },
  {
    label: '.网店',
    value: '.网店',
    tips: '企业塑造电商品牌的优选',
    href: 'http://www.xinnet.com/domain/wangdian.html',
    addCart: false,
    query: false,
    show: true,
  },
  {
    label: '.佛山',
    value: '.佛山',
    tips: '打造区域城市名片',
    href: '',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.招聘',
    value: '.招聘',
    tips: '',
    href: '',
    addCart: false,
    query: false,
    show: true,
    checked: true
  },
  {
    label: '.餐厅',
    value: '.餐厅',
    tips: '',
    href: '',
    addCart: false,
    query: false,
    show: true,
  },
]
const SUFFIX_EXACT = [
  {
    label: '.com',
    value: '.com',
    common: true,
    hot: true,
    checked: true
  },
  {
    label: '.cn',
    value: '.cn',
    common: true,
    hot: true,
    checked: true,
    activity: {
      goodsCode: 'GDxin000206,GDxin000205',
      list: [
        {
          goodsCode: 'GDxin000205',
          name: 'activity1',
          title: '同时购买虚机特惠01 组合价100元，点击选购',
          price: 0,
          priceSale: 0,
          addCart: false,
          show: true,
          href: 'https://host.xinnet.com/index#virtual/list/creat_virtual?os=WIN&type=WINDOWS_DISCOUNT_PRODUCT&code=48587189046161&limit=12&unit=M&rebatecode=',
        },
      ],
    },
  },
  {
    label: '.xyz',
    value: '.xyz',
    common: true,
    hot: true,
    checked: true
  },
  {
    label: '.net',
    value: '.net',
    common: true,
    hot: true,
    checked: true
  },
  {
    label: '.ltd',
    value: '.ltd',
    common: true,
    cu: true,
  },
  {
    label: '.top',
    value: '.top',
    common: true,
    cu: true,
    checked: true
  },
  {
    label: '.com.cn',
    value: '.com.cn',
    common: true,
    checked: true
  },
  {
    label: '.cc',
    value: '.cc',
    checked: true
  },
  {
    label: '.group',
    value: '.group',
    common: true,
  },
  {
    label: '.shop',
    value: '.shop',
    cu: true,
    checked: true
  },
  {
    label: '.vip',
    value: '.vip',
    common: true,
    hot: true,
    checked: true
  },
  {
    label: '.site',
    value: '.site',
    cu: true,
    activity: {
      goodsCode: '59183916620730',
      list: [
        {
          goodsCode: '59183916620730',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 810,
          priceSale: 122,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.art',
    value: '.art',
    cu: true,
  },
  {
    label: '.tv',
    value: '.tv',
    cu: true,
  },
  {
    label: '.club',
    value: '.club',
    common: true,
    cu: true,
  },
  {
    label: '.wiki',
    value: '.wiki',
  },
  {
    label: '.online',
    value: '.online',
    cu: true,
    activity: {
      goodsCode: '16291022742797',
      list: [
        {
          goodsCode: '16291022742797',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 1010,
          priceSale: 130,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.net.cn',
    value: '.net.cn',
  },
  {
    label: '.cloud',
    value: '.cloud',
    common: true,
  },
  {
    label: '.gov.cn',
    value: '.gov.cn',
  },
  {
    label: '.fun',
    value: '.fun',
    activity: {
      goodsCode: '20197792585061',
      list: [
        {
          goodsCode: '20197792585061',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 610,
          priceSale: 122,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.store',
    value: '.store',
    cu: true,
    activity: {
      goodsCode: '33918118850029',
      list: [
        {
          goodsCode: '33918118850029',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 1610,
          priceSale: 138,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.wang',
    value: '.wang',
    common: true,
  },
  {
    label: '.ac.cn',
    value: '.ac.cn',
  },
  {
    label: '.tech',
    value: '.tech',
    cu: true,
    activity: {
      goodsCode: '26066619285049',
      list: [
        {
          goodsCode: '26066619285049',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 1410,
          priceSale: 138,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.pro',
    value: '.pro',
  },
  {
    label: '.biz',
    value: '.biz',
    common: true,
  },
  {
    label: '.space',
    value: '.space',
    activity: {
      goodsCode: '60519508862366',
      list: [
        {
          goodsCode: '60519508862366',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 610,
          priceSale: 122,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.co',
    value: '.co',
    cu: true,
  },
  {
    label: '.link',
    value: '.link',
    cu: true,
  },
  {
    label: '.info',
    value: '.info',
    common: true,
    checked: true
  },
  {
    label: '.team',
    value: '.team',
  },
  {
    label: '.mobi',
    value: '.mobi',
    checked: true
  },
  {
    label: '.city',
    value: '.city',
  },
  {
    label: '.life',
    value: '.life',
  },
  {
    label: '.zone',
    value: '.zone',
  },
  {
    label: '.asia',
    value: '.asia',
  },
  {
    label: '.host',
    value: '.host',
    activity: {
      goodsCode: '60516702826205',
      list: [
        {
          goodsCode: '60516702826205',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 2610,
          priceSale: 130,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.website',
    value: '.website',
    activity: {
      goodsCode: '95675822055086',
      list: [
        {
          goodsCode: '95675822055086',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 610,
          priceSale: 122,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.world',
    value: '.world',
  },
  {
    label: '.center',
    value: '.center',
  },
  {
    label: '.cool',
    value: '.cool',
  },
  {
    label: '.ren',
    value: '.ren',
  },
  {
    label: '.company',
    value: '.company',
  },
  {
    label: '.plus',
    value: '.plus',
  },
  {
    label: '.video',
    value: '.video',
  },
  {
    label: '.org.cn',
    value: '.org.cn',
  },
  {
    label: '.pub',
    value: '.pub',
  },
  {
    label: '.email',
    value: '.email',
  },
  {
    label: '.live',
    value: '.live',
  },
  {
    label: '.run',
    value: '.run',
  },
  {
    label: '.love',
    value: '.love',
  },
  {
    label: '.show',
    value: '.show',
  },
  {
    label: '.work',
    value: '.work',
  },
  {
    label: '.ink',
    value: '.ink',
  },
  {
    label: '.fund',
    value: '.fund',
  },
  {
    label: '.red',
    value: '.red',
  },
  {
    label: '.chat',
    value: '.chat',
  },
  {
    label: '.today',
    value: '.today',
  },
  {
    label: '.press',
    value: '.press',
    activity: {
      goodsCode: '24426527565481',
      list: [
        {
          goodsCode: '24426527565481',
          name: 'activity2',
          title: '5年优惠',
          year: 5,
          price: 1970,
          priceSale: 130,
          addCart: false,
          show: true,
        },
      ],
    },
  },
  {
    label: '.social',
    value: '.social',
  },
  {
    label: '.gold',
    value: '.gold',
  },
  {
    label: '.design',
    value: '.design',
  },
  {
    label: '.auto',
    value: '.auto',
  },
  {
    label: '.guru',
    value: '.guru',
  },
  {
    label: '.black',
    value: '.black',
  },
  {
    label: '.blue',
    value: '.blue',
  },
  {
    label: '.green',
    value: '.green',
  },
  {
    label: '.pink',
    value: '.pink',
  },
  {
    label: '.poker',
    value: '.poker',
  },
  {
    label: '.news',
    value: '.news',
  },
  {
    label: '.icu',
    value: '.icu',
  },
  {
    label: '.me',
    value: '.me',
  },
  {
    label: '.pw',
    value: '.pw',
  },
  {
    label: '.storage',
    value: '.storage',
  },
  {
    label: '.theatre',
    value: '.theatre',
  },
  {
    label: '.college',
    value: '.college',
  },
  {
    label: '.uno',
    value: '.uno',
  },
  {
    label: '.monster',
    value: '.monster',
  },
  {
    label: '.protection',
    value: '.protection',
  },
  {
    label: '.rent',
    value: '.rent',
  },
  {
    label: '.fans',
    value: '.fans',
  },
  {
    label: '.security',
    value: '.security',
  },
  {
    label: '.band',
    value: '.band',
  },
  {
    label: '.vin',
    value: '.vin',
  },
  {
    label: '.luxe',
    value: '.luxe',
  },
  {
    label: '.cyou',
    value: '.cyou',
  },
  {
    label: '.cafe',
    value: '.cafe',
  },
  {
    label: '.sale',
    value: '.sale',
  },
  {
    label: '.shopping',
    value: '.shopping',
  },
  {
    label: '.school',
    value: '.school',
  },
  {
    label: '.fan',
    value: '.fan',
  },
  {
    label: '.studio',
    value: '.studio',
  },
  {
    label: '.global',
    value: '.global',
  },
  {
    label: '.fyi',
    value: '.fyi',
  },
  {
    label: '.games',
    value: '.games',
  },
  {
    label: '.technology',
    value: '.technology',
  },
  {
    label: '.fit',
    value: '.fit',
  },
  {
    label: '.yoga',
    value: '.yoga',
  },
  {
    label: '.baby',
    value: '.baby',
  },
  {
    label: '.fashion',
    value: '.fashion',
  },
  {
    label: '.mba',
    value: '.mba',
  },
  {
    label: '.bond',
    value: '.bond',
  },
  {
    label: '.market',
    value: '.market',
  },
  {
    label: '.cab',
    value: '.cab',
  },
  {
    label: '.cash',
    value: '.cash',
  },
  {
    label: '.bio',
    value: '.bio',
  },
  {
    label: '.media',
    value: '.media',
  },
  {
    label: '.kim',
    value: '.kim',
  },
  {
    label: '.ski',
    value: '.ski',
  },
  {
    label: '.pet',
    value: '.pet',
  },
]
export default
  {
    ORDER_GOODS_TYPE,
    BUSINESS_LIST,
    UNIT,
    ORDER_TYPE,
    REGISTRANT_ID_TYPE_I,
    REGISTRANT_ID_TYPE_E,
    DOMAIN_TRANSFER_STATUS,
    DOMAIN_CHANGE_TYPE,
    REAL_NAME_VERIFY_STATUS,
    DOMAIN_NAME_VERIFY_STATUS,
    IMPORTANT_FLAG,
    RENEWFLAG,
    UPDATEFLAG,
    TRANSFERLOCKFLAG,
    DELETELOCKFLAG,
    WHOISPRIVACYFLAG,
    BACKENDLOCKFLAG,
    SERVICE_TYPE,
    SERVICE_STATE,
    RECORD_USER_EVENT_TYPE,
    RECORD_DOMAIN_EVENT_TYPE,
    MGMT_TYPE,
    MONITOR_LOG,
    DOMAIN_SUFFIX,
    PAY_TYPE,
    QUESTION_TYPE,
    QUESTION_MODIFY_TYPE,
    SECURITY_TYPE,
    ORDER_PAY_TYPE,
    ORDER_MODE,
    RECORD_FOCUS_DOMAIN_EVENT_TYPE,
    BRAND_LEVEL,
    SUFFIX_ADMINISTRATIVE_AREA,
    SUFFIX_CHINESE,
    SUFFIX_EXACT
  }



// WEBPACK FOOTER //
// ./src/global/datas.js